import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  ViewChild
} from '@angular/core';

import { DropdownSingleComponent } from './components/dropdown-single.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { app_ShellService, EModalSize, EToasterType, EToasterPosition } from './app.shell.service';
import { app_OperationService } from './app.operation.service';
import { app_DatasourceService } from './app.datasource.index';
import { app_FlowService } from './app.flow.index';
import { app_ReportService } from './app.report.index';
import { app_LocalizationService } from './app.localization.service';
import { Language } from './localization.service';
import { $types } from './app.types'

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'app-home',
  templateUrl: './app.home.component.html'
})
export class app_homeComponent implements OnInit {

  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  //#endregion

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  toolbar = {
  };


  fieldsets = {
  };

  @ViewChild('dd_config') dd_config: DropdownSingleComponent;
  @ViewChild('dd_method') dd_method: DropdownSingleComponent;

  constructor(
    private utils: UtilsService,
private settings: SettingsValuesService,
private shell: app_ShellService,
private datasources: app_DatasourceService,
private flows: app_FlowService,
private reports: app_ReportService,
private localization: app_LocalizationService,
private operations: app_OperationService,
) { 

  }

  ngOnInit(): void {
    this.$init();
  
  }

  initialized = false;

  async $init() {
    this.title = 'Home';
    this.initialized = true;
  }

  close() {
    this.$finish.emit();
  }

  typeValue = null;
  typeList = [
    {
      key: 6,
      name: 'Datasource'
    },
    {
      key: 9,
      name: 'Function'
    }
  ];

  async typeDisplayWithFn(value: any): Promise<string> {
    return this.typeList.find(item => item.key === value)?.name;
  }

  async typeOptionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    if (this.utils.isDefinedTrimmed(filterText)) {
      return { list: this.typeList.filter(item => item.name.startsWith(filterText)), totalCount: this.typeList.length };
    } else {
      return { list: this.typeList, totalCount: this.typeList.length };
    }
  }

  typeValueChange(value) {
    this.typeValue = value;
    this.configValueChange(null);
    this.dd_config.clearListData();
  }


  configValue = null;
  config = null;
  configList = [
    {
      key: 'A_Configurations',
      name: 'A_Configurations' + ' ('+ 'Ultraship' +')',
      referenceName: 'A_Configurations',
      appReferenceName: 'Ultraship',
      type: 9,
    },
    {
      key: 'A_SFTP',
      name: 'A_SFTP' + ' ('+ 'Ultraship' +')',
      referenceName: 'A_SFTP',
      appReferenceName: 'Ultraship',
      type: 9,
    },
    {
      key: 'A_TEST',
      name: 'A_TEST' + ' ('+ 'Ultraship' +')',
      referenceName: 'A_TEST',
      appReferenceName: 'Ultraship',
      type: 9,
    },
    {
      key: 'A_UnitTest',
      name: 'A_UnitTest' + ' ('+ 'Ultraship' +')',
      referenceName: 'A_UnitTest',
      appReferenceName: 'Ultraship',
      type: 9,
    },
    {
      key: 'DEPRECATED_import_inbound_shipment_request_payload',
      name: 'DEPRECATED_import_inbound_shipment_request_payload' + ' ('+ 'Ultraship' +')',
      referenceName: 'DEPRECATED_import_inbound_shipment_request_payload',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'loadContainerId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'orderId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'shipmentId',
            type: 'number',
            isCollection: false
          },
        ]
    },
    {
      key: 'DEPRECATED_insert_ultraship_inbound_shipment_to_staging',
      name: 'DEPRECATED_insert_ultraship_inbound_shipment_to_staging' + ' ('+ 'Ultraship' +')',
      referenceName: 'DEPRECATED_insert_ultraship_inbound_shipment_to_staging',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'inboundShipmentPayload',
            type: 'string',
            isCollection: true
          },
          {
            required: false,
            id: 'inboundShipmentNumber',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'entity_update_trackers',
      name: 'entity_update_trackers' + ' ('+ 'Ultraship' +')',
      referenceName: 'entity_update_trackers',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'payload',
            type: 'object',
            isCollection: true
          },
          {
            required: true,
            id: 'action',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'skip',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'take',
            type: 'number',
            isCollection: false
          },
          {
            required: true,
            id: 'application_name',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'full_text_search',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'entity_update_trackers_delete',
      name: 'entity_update_trackers_delete' + ' ('+ 'Ultraship' +')',
      referenceName: 'entity_update_trackers_delete',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'input',
            type: 'object',
            isCollection: true
          },
          {
            required: true,
            id: 'criteria',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'entity_update_trackers_distinct',
      name: 'entity_update_trackers_distinct' + ' ('+ 'Ultraship' +')',
      referenceName: 'entity_update_trackers_distinct',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'input',
            type: 'object',
            isCollection: true
          },
          {
            required: false,
            id: 'criteria',
            type: 'object',
            isCollection: false
          },
          {
            required: true,
            id: 'field',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'top',
            type: 'number',
            isCollection: false
          },
        ]
    },
    {
      key: 'entity_update_trackers_get',
      name: 'entity_update_trackers_get' + ' ('+ 'Ultraship' +')',
      referenceName: 'entity_update_trackers_get',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'input',
            type: 'object',
            isCollection: true
          },
          {
            required: true,
            id: 'criteria',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'entity_update_trackers_get_one',
      name: 'entity_update_trackers_get_one' + ' ('+ 'Ultraship' +')',
      referenceName: 'entity_update_trackers_get_one',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'input',
            type: 'object',
            isCollection: true
          },
          {
            required: true,
            id: 'criteria',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'entity_update_trackers_purge',
      name: 'entity_update_trackers_purge' + ' ('+ 'Ultraship' +')',
      referenceName: 'entity_update_trackers_purge',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'criteria',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'entity_update_trackers_update',
      name: 'entity_update_trackers_update' + ' ('+ 'Ultraship' +')',
      referenceName: 'entity_update_trackers_update',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'input',
            type: 'object',
            isCollection: true
          },
          {
            required: true,
            id: 'criteria',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'entity_update_trackers_write',
      name: 'entity_update_trackers_write' + ' ('+ 'Ultraship' +')',
      referenceName: 'entity_update_trackers_write',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'input',
            type: 'object',
            isCollection: true
          },
          {
            required: true,
            id: 'criteria',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'export_ultraship_outbound_order',
      name: 'export_ultraship_outbound_order' + ' ('+ 'Ultraship' +')',
      referenceName: 'export_ultraship_outbound_order',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'ultrashipOrdersPayload',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'messageTransactionId',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'export_ultraship_outbound_shipment',
      name: 'export_ultraship_outbound_shipment' + ' ('+ 'Ultraship' +')',
      referenceName: 'export_ultraship_outbound_shipment',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'shipmentWsPayload',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'messageTransactionId',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'get_http_configuration',
      name: 'get_http_configuration' + ' ('+ 'Ultraship' +')',
      referenceName: 'get_http_configuration',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'application_name',
            type: 'string',
            isCollection: false
          },
          {
            required: true,
            id: 'instance',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'get_projects_configuration',
      name: 'get_projects_configuration' + ' ('+ 'Ultraship' +')',
      referenceName: 'get_projects_configuration',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'application_name',
            type: 'string',
            isCollection: false
          },
          {
            required: true,
            id: 'instance',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'get_sftp_configuration',
      name: 'get_sftp_configuration' + ' ('+ 'Ultraship' +')',
      referenceName: 'get_sftp_configuration',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'application_name',
            type: 'string',
            isCollection: false
          },
          {
            required: true,
            id: 'instance',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'import_inbound_shipment_request_payload',
      name: 'import_inbound_shipment_request_payload' + ' ('+ 'Ultraship' +')',
      referenceName: 'import_inbound_shipment_request_payload',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'ultrashipShipmentPayload',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'messageStorageId',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'messageTransactionId',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'insert_shipment_payload_to_staging',
      name: 'insert_shipment_payload_to_staging' + ' ('+ 'Ultraship' +')',
      referenceName: 'insert_shipment_payload_to_staging',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'shipmentPayload',
            type: 'object',
            isCollection: false
          },
          {
            required: false,
            id: 'storageMessageId',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'storageTransactionId',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'main_get_and_process_ultraship_documents_from_sftp',
      name: 'main_get_and_process_ultraship_documents_from_sftp' + ' ('+ 'Ultraship' +')',
      referenceName: 'main_get_and_process_ultraship_documents_from_sftp',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'ftpWorkingFolder',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'ftpArchiveFolder',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'ftpErroFolder',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'ftpFileExtension',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'main_insert_ultraship_outbound_orders_to_staging',
      name: 'main_insert_ultraship_outbound_orders_to_staging' + ' ('+ 'Ultraship' +')',
      referenceName: 'main_insert_ultraship_outbound_orders_to_staging',
      appReferenceName: 'Ultraship',
      type: 9,
    },
    {
      key: 'main_insert_ultraship_outbound_shipment_to_staging',
      name: 'main_insert_ultraship_outbound_shipment_to_staging' + ' ('+ 'Ultraship' +')',
      referenceName: 'main_insert_ultraship_outbound_shipment_to_staging',
      appReferenceName: 'Ultraship',
      type: 9,
    },
    {
      key: 'main_process_ultraship_inbound_shipments_from_staging',
      name: 'main_process_ultraship_inbound_shipments_from_staging' + ' ('+ 'Ultraship' +')',
      referenceName: 'main_process_ultraship_inbound_shipments_from_staging',
      appReferenceName: 'Ultraship',
      type: 9,
    },
    {
      key: 'main_process_ultraship_outbound_orders_from_staging',
      name: 'main_process_ultraship_outbound_orders_from_staging' + ' ('+ 'Ultraship' +')',
      referenceName: 'main_process_ultraship_outbound_orders_from_staging',
      appReferenceName: 'Ultraship',
      type: 9,
    },
    {
      key: 'main_process_ultraship_outbound_orders_update_from_staging',
      name: 'main_process_ultraship_outbound_orders_update_from_staging' + ' ('+ 'Ultraship' +')',
      referenceName: 'main_process_ultraship_outbound_orders_update_from_staging',
      appReferenceName: 'Ultraship',
      type: 9,
    },
    {
      key: 'main_process_ultraship_outbound_shipments_from_staging',
      name: 'main_process_ultraship_outbound_shipments_from_staging' + ' ('+ 'Ultraship' +')',
      referenceName: 'main_process_ultraship_outbound_shipments_from_staging',
      appReferenceName: 'Ultraship',
      type: 9,
    },
    {
      key: 'map_outbound_order_request_payload',
      name: 'map_outbound_order_request_payload' + ' ('+ 'Ultraship' +')',
      referenceName: 'map_outbound_order_request_payload',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'orderId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'shipmentId',
            type: 'number',
            isCollection: false
          },
        ]
    },
    {
      key: 'map_outbound_order_update_request_payload',
      name: 'map_outbound_order_update_request_payload' + ' ('+ 'Ultraship' +')',
      referenceName: 'map_outbound_order_update_request_payload',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'orderId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'shipmentId',
            type: 'number',
            isCollection: false
          },
        ]
    },
    {
      key: 'map_outbound_shipment_request_payload',
      name: 'map_outbound_shipment_request_payload' + ' ('+ 'Ultraship' +')',
      referenceName: 'map_outbound_shipment_request_payload',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'loadContainerId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'orderId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'shipmentId',
            type: 'number',
            isCollection: false
          },
        ]
    },
    {
      key: 'parse_and_insert_response_request_payload_to_staging',
      name: 'parse_and_insert_response_request_payload_to_staging' + ' ('+ 'Ultraship' +')',
      referenceName: 'parse_and_insert_response_request_payload_to_staging',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'payload',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'storageMessageId',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'storageTransactionId',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'parse_and_process_http_request_response_from_ultraship',
      name: 'parse_and_process_http_request_response_from_ultraship' + ' ('+ 'Ultraship' +')',
      referenceName: 'parse_and_process_http_request_response_from_ultraship',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'responsePayload',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'responseContext',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'parse_and_process_order_request_response_from_ultraship',
      name: 'parse_and_process_order_request_response_from_ultraship' + ' ('+ 'Ultraship' +')',
      referenceName: 'parse_and_process_order_request_response_from_ultraship',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'ultrashipOrderResponsePayload',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'messageTransactionId',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'parse_and_process_shipment_request_response_from_ultraship',
      name: 'parse_and_process_shipment_request_response_from_ultraship' + ' ('+ 'Ultraship' +')',
      referenceName: 'parse_and_process_shipment_request_response_from_ultraship',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'ultrashipShipmentResponsePayload',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'messageTransactionId',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'parse_order_v4_request_payload',
      name: 'parse_order_v4_request_payload' + ' ('+ 'Ultraship' +')',
      referenceName: 'parse_order_v4_request_payload',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'payload',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'parse_shipment_v4_request_payload',
      name: 'parse_shipment_v4_request_payload' + ' ('+ 'Ultraship' +')',
      referenceName: 'parse_shipment_v4_request_payload',
      appReferenceName: 'Ultraship',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'payload',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'ds_get_address_by_accountId_addressId',
      name: 'ds_get_address_by_accountId_addressId' + ' ('+ 'Ultraship' +')',
      referenceName: 'ds_get_address_by_accountId_addressId',
      appReferenceName: 'Ultraship',
      type: 6,
      methods: [
        {
          key: 'get',
          name: 'get',
          inParams: [
            {
              required: true,
              id: 'accountId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'addressId',
              type: 'number',
              isCollection: false
            },
          ]
        },
      ]
    },
    {
      key: 'ds_get_address_by_warehouseId',
      name: 'ds_get_address_by_warehouseId' + ' ('+ 'Ultraship' +')',
      referenceName: 'ds_get_address_by_warehouseId',
      appReferenceName: 'Ultraship',
      type: 6,
      methods: [
        {
          key: 'get',
          name: 'get',
          inParams: [
            {
              required: true,
              id: 'warehouseId',
              type: 'number',
              isCollection: false
            },
          ]
        },
      ]
    },
    {
      key: 'ds_get_all_projects',
      name: 'ds_get_all_projects' + ' ('+ 'Ultraship' +')',
      referenceName: 'ds_get_all_projects',
      appReferenceName: 'Ultraship',
      type: 6,
      methods: [
        {
          key: 'get',
          name: 'get',
        },
        {
          key: 'getList',
          name: 'getList',
          inParams: [
            {
              required: false,
              id: '$top',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: '$skip',
              type: 'number',
              isCollection: false
            },
          ]
        },
        {
          key: 'getByKeys',
          name: 'getByKeys',
          inParams: [
            {
              required: true,
              id: '$keys',
              type: 'number',
              isCollection: true
            },
          ]
        },
      ]
    },
    {
      key: 'ds_get_load_container_by_lookupCode',
      name: 'ds_get_load_container_by_lookupCode' + ' ('+ 'Ultraship' +')',
      referenceName: 'ds_get_load_container_by_lookupCode',
      appReferenceName: 'Ultraship',
      type: 6,
      methods: [
        {
          key: 'get',
          name: 'get',
          inParams: [
            {
              required: true,
              id: 'lookupCode',
              type: 'string',
              isCollection: false
            },
          ]
        },
        {
          key: 'getList',
          name: 'getList',
          inParams: [
            {
              required: true,
              id: 'lookupCode',
              type: 'string',
              isCollection: false
            },
            {
              required: false,
              id: '$top',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: '$skip',
              type: 'number',
              isCollection: false
            },
          ]
        },
        {
          key: 'getByKeys',
          name: 'getByKeys',
          inParams: [
            {
              required: true,
              id: 'lookupCode',
              type: 'string',
              isCollection: false
            },
            {
              required: true,
              id: '$keys',
              type: 'number',
              isCollection: true
            },
          ]
        },
      ]
    },
    {
      key: 'ds_get_load_container_details_by_loadContainerId',
      name: 'ds_get_load_container_details_by_loadContainerId' + ' ('+ 'Ultraship' +')',
      referenceName: 'ds_get_load_container_details_by_loadContainerId',
      appReferenceName: 'Ultraship',
      type: 6,
      methods: [
        {
          key: 'get',
          name: 'get',
          inParams: [
            {
              required: true,
              id: 'loadContainerId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'orderId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'shipmentId',
              type: 'number',
              isCollection: false
            },
          ]
        },
        {
          key: 'getList',
          name: 'getList',
          inParams: [
            {
              required: true,
              id: 'loadContainerId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'orderId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'shipmentId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: '$top',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: '$skip',
              type: 'number',
              isCollection: false
            },
          ]
        },
        {
          key: 'getByKeys',
          name: 'getByKeys',
          inParams: [
            {
              required: true,
              id: 'loadContainerId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'orderId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'shipmentId',
              type: 'number',
              isCollection: false
            },
            {
              required: true,
              id: '$keys',
              type: 'number',
              isCollection: true
            },
          ]
        },
      ]
    },
    {
      key: 'ds_get_load_containers_by_project_and_filters',
      name: 'ds_get_load_containers_by_project_and_filters' + ' ('+ 'Ultraship' +')',
      referenceName: 'ds_get_load_containers_by_project_and_filters',
      appReferenceName: 'Ultraship',
      type: 6,
      methods: [
        {
          key: 'get',
          name: 'get',
          inParams: [
            {
              required: false,
              id: 'projectLookupCode',
              type: 'string',
              isCollection: false
            },
          ]
        },
        {
          key: 'getList',
          name: 'getList',
          inParams: [
            {
              required: false,
              id: 'projectLookupCode',
              type: 'string',
              isCollection: false
            },
            {
              required: false,
              id: '$top',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: '$skip',
              type: 'number',
              isCollection: false
            },
          ]
        },
        {
          key: 'getByKeys',
          name: 'getByKeys',
          inParams: [
            {
              required: false,
              id: 'projectLookupCode',
              type: 'string',
              isCollection: false
            },
            {
              required: true,
              id: '$keys',
              type: 'number',
              isCollection: true
            },
          ]
        },
      ]
    },
    {
      key: 'ds_get_load_containers_to_send',
      name: 'ds_get_load_containers_to_send' + ' ('+ 'Ultraship' +')',
      referenceName: 'ds_get_load_containers_to_send',
      appReferenceName: 'Ultraship',
      type: 6,
      methods: [
        {
          key: 'getList',
          name: 'getList',
          inParams: [
            {
              required: false,
              id: '$top',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: '$skip',
              type: 'number',
              isCollection: false
            },
          ]
        },
      ]
    },
    {
      key: 'ds_get_order_by_lookupCode_references',
      name: 'ds_get_order_by_lookupCode_references' + ' ('+ 'Ultraship' +')',
      referenceName: 'ds_get_order_by_lookupCode_references',
      appReferenceName: 'Ultraship',
      type: 6,
      methods: [
        {
          key: 'get',
          name: 'get',
          inParams: [
            {
              required: true,
              id: 'lookupCode',
              type: 'string',
              isCollection: false
            },
            {
              required: false,
              id: 'ownerReference',
              type: 'string',
              isCollection: false
            },
            {
              required: false,
              id: 'vendorReference',
              type: 'string',
              isCollection: false
            },
          ]
        },
      ]
    },
    {
      key: 'ds_get_order_details_by_orderId_shipmentId',
      name: 'ds_get_order_details_by_orderId_shipmentId' + ' ('+ 'Ultraship' +')',
      referenceName: 'ds_get_order_details_by_orderId_shipmentId',
      appReferenceName: 'Ultraship',
      type: 6,
      methods: [
        {
          key: 'get',
          name: 'get',
          inParams: [
            {
              required: true,
              id: 'orderId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'shipmentId',
              type: 'number',
              isCollection: false
            },
          ]
        },
        {
          key: 'getList',
          name: 'getList',
          inParams: [
            {
              required: true,
              id: 'orderId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'shipmentId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: '$top',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: '$skip',
              type: 'number',
              isCollection: false
            },
          ]
        },
        {
          key: 'getByKeys',
          name: 'getByKeys',
          inParams: [
            {
              required: true,
              id: 'orderId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'shipmentId',
              type: 'number',
              isCollection: false
            },
            {
              required: true,
              id: '$keys',
              type: 'number',
              isCollection: true
            },
          ]
        },
      ]
    },
    {
      key: 'ds_get_orderaddresses_by_orderId_typeId',
      name: 'ds_get_orderaddresses_by_orderId_typeId' + ' ('+ 'Ultraship' +')',
      referenceName: 'ds_get_orderaddresses_by_orderId_typeId',
      appReferenceName: 'Ultraship',
      type: 6,
      methods: [
        {
          key: 'get',
          name: 'get',
          inParams: [
            {
              required: true,
              id: 'orderId',
              type: 'number',
              isCollection: false
            },
            {
              required: true,
              id: 'typeId',
              type: 'number',
              isCollection: false
            },
          ]
        },
      ]
    },
    {
      key: 'ds_get_orders_by_project_and_filters',
      name: 'ds_get_orders_by_project_and_filters' + ' ('+ 'Ultraship' +')',
      referenceName: 'ds_get_orders_by_project_and_filters',
      appReferenceName: 'Ultraship',
      type: 6,
      methods: [
        {
          key: 'get',
          name: 'get',
          inParams: [
            {
              required: false,
              id: 'projectLookupCode',
              type: 'string',
              isCollection: false
            },
          ]
        },
        {
          key: 'getList',
          name: 'getList',
          inParams: [
            {
              required: false,
              id: 'projectLookupCode',
              type: 'string',
              isCollection: false
            },
            {
              required: false,
              id: '$top',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: '$skip',
              type: 'number',
              isCollection: false
            },
          ]
        },
        {
          key: 'getByKeys',
          name: 'getByKeys',
          inParams: [
            {
              required: false,
              id: 'projectLookupCode',
              type: 'string',
              isCollection: false
            },
            {
              required: true,
              id: '$keys',
              type: 'number',
              isCollection: true
            },
          ]
        },
      ]
    },
    {
      key: 'ds_get_orders_to_send',
      name: 'ds_get_orders_to_send' + ' ('+ 'Ultraship' +')',
      referenceName: 'ds_get_orders_to_send',
      appReferenceName: 'Ultraship',
      type: 6,
      methods: [
        {
          key: 'getList',
          name: 'getList',
          inParams: [
            {
              required: false,
              id: '$top',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: '$skip',
              type: 'number',
              isCollection: false
            },
          ]
        },
      ]
    },
    {
      key: 'ds_get_project_by_projectId',
      name: 'ds_get_project_by_projectId' + ' ('+ 'Ultraship' +')',
      referenceName: 'ds_get_project_by_projectId',
      appReferenceName: 'Ultraship',
      type: 6,
      methods: [
        {
          key: 'get',
          name: 'get',
          inParams: [
            {
              required: true,
              id: 'projectId',
              type: 'number',
              isCollection: false
            },
          ]
        },
        {
          key: 'getList',
          name: 'getList',
          inParams: [
            {
              required: true,
              id: 'projectId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: '$top',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: '$skip',
              type: 'number',
              isCollection: false
            },
          ]
        },
        {
          key: 'getByKeys',
          name: 'getByKeys',
          inParams: [
            {
              required: true,
              id: 'projectId',
              type: 'number',
              isCollection: false
            },
            {
              required: true,
              id: '$keys',
              type: 'number',
              isCollection: true
            },
          ]
        },
      ]
    },
    {
      key: 'ds_owners_dd',
      name: 'ds_owners_dd' + ' ('+ 'Ultraship' +')',
      referenceName: 'ds_owners_dd',
      appReferenceName: 'Ultraship',
      type: 6,
      methods: [
        {
          key: 'get',
          name: 'get',
          inParams: [
            {
              required: false,
              id: 'statusId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'projectId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'fullTextSearch',
              type: 'string',
              isCollection: false
            },
          ]
        },
        {
          key: 'getList',
          name: 'getList',
          inParams: [
            {
              required: false,
              id: 'statusId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'projectId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'fullTextSearch',
              type: 'string',
              isCollection: false
            },
            {
              required: false,
              id: '$top',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: '$skip',
              type: 'number',
              isCollection: false
            },
          ]
        },
        {
          key: 'getByKeys',
          name: 'getByKeys',
          inParams: [
            {
              required: false,
              id: 'statusId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'projectId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'fullTextSearch',
              type: 'string',
              isCollection: false
            },
            {
              required: true,
              id: '$keys',
              type: 'number',
              isCollection: true
            },
          ]
        },
      ]
    },
    {
      key: 'ds_projects_dd',
      name: 'ds_projects_dd' + ' ('+ 'Ultraship' +')',
      referenceName: 'ds_projects_dd',
      appReferenceName: 'Ultraship',
      type: 6,
      methods: [
        {
          key: 'get',
          name: 'get',
          inParams: [
            {
              required: false,
              id: 'statusId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'ownerId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'fullTextSearch',
              type: 'string',
              isCollection: false
            },
            {
              required: false,
              id: 'excludedProjectIds',
              type: 'number',
              isCollection: true
            },
          ]
        },
        {
          key: 'getList',
          name: 'getList',
          inParams: [
            {
              required: false,
              id: 'statusId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'ownerId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'fullTextSearch',
              type: 'string',
              isCollection: false
            },
            {
              required: false,
              id: 'excludedProjectIds',
              type: 'number',
              isCollection: true
            },
            {
              required: false,
              id: '$top',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: '$skip',
              type: 'number',
              isCollection: false
            },
          ]
        },
        {
          key: 'getByKeys',
          name: 'getByKeys',
          inParams: [
            {
              required: false,
              id: 'statusId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'ownerId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'fullTextSearch',
              type: 'string',
              isCollection: false
            },
            {
              required: false,
              id: 'excludedProjectIds',
              type: 'number',
              isCollection: true
            },
            {
              required: true,
              id: '$keys',
              type: 'number',
              isCollection: true
            },
          ]
        },
      ]
    },
  ];

  async configDisplayWithFn(value: any): Promise<string> {
    return this.configList.find(item => item.key === value)?.name;
  }

  async configOptionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    let list = this.configList.filter(item => item.type === this.typeValue);
    const totalCount = list.length;
    if (this.utils.isDefinedTrimmed(filterText)) {
      list = list.filter(item => item.name.startsWith(filterText));
    }

    return { list, totalCount };
  }
  
  configValueChange(value) {
    this.configValue = value;
    this.config = this.configList.find(item => item.key === value);
    this.methodValueChange(null);
    this.dd_method.clearListData();
  }

  get hasMethods():boolean {
    return this.config && this.config?.methods;
  }
  
  method = null;
  methodValue = null;

  async methodDisplayWithFn(value: any): Promise<string> {
    return value;
  }

  async methodOptionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    let list = this.config.methods;
    const totalCount = list.length;
    if (this.utils.isDefinedTrimmed(filterText)) {
      list = list.filter(item => item.name.startsWith(filterText));
    }

    return { list, totalCount };
  }
  
  methodValueChange(value) {
    this.methodValue = value;
    this.result = null;    
    if (this.hasMethods) {
      this.method = this.config.methods.find(item => item.key === value);
    } else {
      this.method = null;
    }
    this.onInParamChanged();
  }


  get inParams() {
    if (this.config) {
      if (this.config.methods) {
        if (this.method) {
          return this.method.inParams;
        }
      } else {
        return this.config.inParams;
      }
    }
    return null;
  }

  previewInParams = null;
  onInParamChanged() {
    this.previewInParams = {};
    if (this.inParams && this.inParams.length) {
      const inParams: { [key: string]: any } = {};
      this.inParams.forEach(ip => {
        inParams[ip.id] = this.evaluateValue(ip.value);
      });
      this.previewInParams = inParams;
    }
  }

  evaluateValue(value: string) {
    const val = this.utils.isDefinedTrimmed(value) ? `(${value})` : value;
    const f = new Function(`{ return ${val} }`);
    return f();
  }

  get canExecute (): boolean {
    if (!this.config) {
      return false;
    }
    if (this.config.type === 6 && !this.methodValue) {
      return false;
    } 
    return true;
  }

  result: any;
  async run() {
    if (this.config.type === 6) {
      this.result = await this.datasources[this.config.appReferenceName][this.config.referenceName][this.methodValue](this.previewInParams);
    } else if (this.config.type === 9) {
      this.result = await this.flows[this.config.appReferenceName][this.config.referenceName](this.previewInParams);
    }
  }  
}
